import Link from 'next/link';
import React from 'react';

import CompanyLogo from '~components/CompanyLogo';
import { SalaryRank } from '~types/ranking';
import { millionFormattedtoString } from '~utils/formatted/number';
import { getShortenedAddress } from '~utils/locationFormat';

import { COMPANY_TYPE } from './constants';
import * as S from './style';

type Props = SalaryRank & {
  eventTitle: string;
};

export default function RankingCard({
  PK_NM_HASH,
  rank,
  name,
  location,
  category,
  salary,
  logo,
  locationCode,
  eventTitle,
}: Props) {
  return (
    <S.RankingCardWrapper>
      <Link href={`/company/${PK_NM_HASH}`}>
        <a
          data-attribute-id='home__company__click'
          data-company-name={name}
          data-company-type={COMPANY_TYPE[category] || COMPANY_TYPE.DEFAULT}
          data-rank={rank}
          data-theme={eventTitle}>
          <S.Rank>{rank}</S.Rank>
          <CompanyLogo PK_NM_HASH={PK_NM_HASH} logoCss={S.logoCss} hasBorder={false} />
          <S.CompanyInfo>
            <p>{name}</p>
            <p>
              {getShortenedAddress(locationCode || '', location)}
              {!!category && category !== 'CORP' && (
                <S.Tag>{COMPANY_TYPE[category] || COMPANY_TYPE.DEFAULT}</S.Tag>
              )}
            </p>
          </S.CompanyInfo>
          {!!salary && <S.RankData>평균 {millionFormattedtoString(salary)}만원</S.RankData>}
        </a>
      </Link>
    </S.RankingCardWrapper>
  );
}
